module.exports = __webpack_public_path__ + "7accab157abaf42f8d9dbd7b58b11cd3.svg";